<template>
  <div style="min-width: 10rem;">
    <template v-if="isReseller">
      <div class="d-flex align-center text-body-2">
        <v-icon size="18" class="mr-1" color="#586CDA">mdi-account-tie</v-icon>
        <span>Reseller: {{ resellerName }}</span>
      </div>
    </template>
    <template v-else>
      <v-select
        v-model="selectedCid"
        @update:modelValue="changeCompanyId"
        :items="cidList"
        item-title="name"
        item-value="value"
        variant="outlined"
        density="compact"
        :disabled="!hasCids"
        hide-details
      ></v-select>
    </template>
  </div>
</template>

<script>
import imanager3Appframe from "@/scripts/imanager3-appframe"
import iStoreUtils from "@/scripts/istore-utils.js"

export default {
  name: "AppHeaderDropdownCid",
  data() {
    return {
      selectedCid: this.$store.state.loginUser.cid,
      isReseller: false,
      resellerName: this.$store.state.loginUser.userName || ""
    }
  },
  computed: {
    rawCids() {
      return Array.isArray(this.$store.state.loginUser.cids)
        ? this.$store.state.loginUser.cids.filter(Boolean)
        : []
    },
    hasCids() {
      return this.rawCids.length > 0
    },
    cidList() {
      if (!this.hasCids) {
        return [{ name: "No CID", value: null }]
      }
      const uniqueCidValues = [...new Set(this.rawCids)]
      return uniqueCidValues.map((cid) => {
        return {
          name: `CID: ${cid}`,
          value: cid
        }
      })
    },
    currentCid() {
      return this.$store.state.loginUser.cid
    }
  },
  created() {
    this.isReseller = (this.$store.state.loginUser.roles || []).some(r => r.name === 'orion_reseller')
    if (this.hasCids && !this.selectedCid) {
      this.selectedCid = this.rawCids[0] || null
    }
  },
  watch: {
    rawCids: {
      immediate: true,
      handler(newCids) {
        if (newCids.length === 0) {
          this.selectedCid = null
          return
        }
        if (!newCids.includes(this.selectedCid)) {
          this.selectedCid = newCids[0]
        }
      }
    },
    currentCid(newCid) {
      if (newCid && newCid !== this.selectedCid && this.rawCids.includes(newCid)) {
        this.selectedCid = newCid
      }
    }
  },
  methods: {
    changeCompanyId() {
      const change_to = this.selectedCid
      if (!change_to) return
      this.sendTrackingAction(
        this.$store.state.loginUser.userId,
        "Changed CID",
        {
          "page": "AppHeader",
          "data": {
            "currentCid": change_to
          }
        }
      )
      this.$store.commit('setCompanyIds', change_to)
      this.$store.commit('setCurrentMenu')
      this.$router.replace('/dashboard')
    },
    async sendTrackingAction(starNumber, action, data){
      await imanager3Appframe.sendTrackingAction({
        starNumber: starNumber,
        pluginName: "main",
        uuid: iStoreUtils.generateTrackingUuid(),
        userAction: action,
        data: data
      })
    }
  }
}
</script>
